<template>
    <el-form size="large" :model="page" v-loading="saving" label-position="top" ref="pageForm">
        <el-form-item prop="title" label="Title" required>
            <el-input v-model="page.title" placeholder="Title" />
        </el-form-item>

        <el-form-item prop="slug" label="URL" required>
            <el-input v-model="page.slug" placeholder="e.g. 'my-new-page'" />
        </el-form-item>

        <el-form-item prop="visible" label="Publish page?">
            <el-switch v-model="page.visible" active-text="Published" inactive-text="Hidden"></el-switch>
        </el-form-item>

        <el-form-item prop="visible" label="Visible for guests?">
            <el-switch v-model="page.guest_visible" active-text="Visible for everyone" inactive-text="Registered users only" :disabled="!page.visible"></el-switch>
        </el-form-item>

        <el-form-item prop="content" label="Page content" required>
            <el-input type="textarea" v-model="page.content" :autosize="{minRows: 10, maxRows: 10}"></el-input>
        </el-form-item>
    </el-form>
    <el-form label-position="top" size="large" :model="page" v-loading="saving" inline>
        <el-form-item>
            <el-button type="primary" @click="validateAndSave">{{saveLabel}}</el-button>
            <el-button type="danger" plain @click="this.$refs.pageForm.clearValidate(); this.page = {}; $emit('cancel')">{{cancelLabel}}</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
import api from '@/lib/api'

export default {
    name: 'EditPageForm',

    props: {
        modelValue: { type: Object, default: undefined },
        saveLabel: { type: String, default: 'Save' },
        cancelLabel: { type: String, default: 'Cancel' },
    },

    emits: [ 'update:modelValue', 'saved', 'cancel' ],

    computed: {
        page: {
            get () { return this.modelValue || {} },
            set (value) { this.$emit('update:modelValue', value) }
        }
    },

    data: () => {
        return {
            saving: false,
            tinymcedata: "",
            editorConfig: {
                height: 200,
                plugins: 'lists',
                toolbar: 'undo redo'
            }
        }
    },

    methods: {
        createPage () {
            this.saving = true

            api.pages.create ( this.page )
            .then ( response => {
                this.page = response.data

                this.$notify({
                    title: 'Success',
                    message: `Page was created.`,
                    type: 'success'
                })

                this.$emit('saved', this.page)
            })
            .catch(error => {
                const err = error?.response?.data?.message || error.message

                this.$notify({
                    title: 'Error',
                    message: `Could not create page: ${err}`,
                    type: 'error'
                })
            })
            .finally (() => {
                this.saving = false
            })
        },

        editPage () {
            this.saving = true
            
            api.pages.edit ( this.page.id, this.page )
            .then ( response => {
                this.page = response.data

                this.$notify({
                    title: 'Success',
                    message: `Page was succesfully saved.`,
                    type: 'success'
                })

                this.$emit('saved', this.page)
            })
            .catch(error => {
                const err = error?.response?.data?.message || error.message

                this.$notify({
                    title: 'Error',
                    message: `Could not edit page: ${err}`,
                    type: 'error'
                })
            })
            .finally (() => {
                this.saving = false
            })
        },
        validateAndSave () {
            this.$refs.pageForm.validate((valid) => {
                if (valid) {
                    if (this.page.id === undefined) {
                        this.createPage()
                    } else {
                        this.editPage()
                    }
                } else {
                    this.$notify({
                        title: 'Error',
                        message: `Form contains errors. Check all input fields.`,
                        type: 'error'
                    })
                }
            })
        }
    }
}
</script>